import {MOMENT_API_DATE_FORMAT, ContractServiceSettings} from "@/settings";
import SessionStorage from "sessionstorage";
import axios from "axios";

class ContractService {
    getCompany(inn) {
        return axios.get(`${ContractServiceSettings.Host}/company/${inn}`)
    }

    createDraftContract(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        let config = {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        }
        if (id)
            config.params = {
                id: id
            }

        return axios.post(`${ContractServiceSettings.Host}/api/edi/draft-contract`, data, config)
    }

    saveDraftContract(contractId, id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        let config = {headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}}
        if (id)
            config.params = {id: id}

        return axios.put(`${ContractServiceSettings.Host}/api/edi/draft-contract/${contractId}`, data, config)
    }

    getDraftContractAll() {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/draft-contract`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    getDraftContract(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/draft-contract/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    getDraftContractSignHashcode(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/sign-draft-contract/hashcode/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    signDraftContract(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${ContractServiceSettings.Host}/api/edi/sign-draft-contract/sign/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    deleteDraftContract(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.delete(`${ContractServiceSettings.Host}/api/edi/draft-contract/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }

    getSellerContracts({buyer}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/contract`, {
            params: {
                buyer: buyer,
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    addSellerContract({seller, buyer, number, date, isPrimary}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.post(`${ContractServiceSettings.Host}/api/edi/contract`, {
            number: number,
            date: date.format(MOMENT_API_DATE_FORMAT),
            seller_inn: seller,
            buyer_inn: buyer,
            is_primary: isPrimary
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    editSellerContract({id, seller, buyer, number, date, isPrimary}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${ContractServiceSettings.Host}/api/edi/contract/${id}`, {
            number: number,
            date: date.format(MOMENT_API_DATE_FORMAT),
            seller_inn: seller,
            buyer_inn: buyer,
            is_primary: isPrimary
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {
                id: id
            }
        })
    }

    getSendDocumentApprove(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${ContractServiceSettings.Host}/api/edi/send-contract-approve/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }
}

export default new ContractService();
